import { IIconProps } from "../types"

export default function IconUR1(props: IIconProps) {
  const width = props.size || props.width || 73
  const height = props.size || props.height || 92
  return (
    <svg
      {...props}
      width={width}
      height={height}
      className={props.className}
      style={props.style}
      viewBox="0 0 73 92"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M36.118 0.824674C38.268 0.984674 40.158 1.37467 42.338 2.19467C44.518 3.00467 46.988 4.24467 49.338 6.09467C51.678 7.95467 53.888 10.4247 56.498 16.0947C59.098 21.7547 62.098 30.6147 64.278 37.5747C66.458 44.5447 67.818 49.6247 68.868 54.4747C69.908 59.3247 70.618 63.9447 71.048 67.8847C71.468 71.8247 71.598 75.0747 71.278 77.8747C70.948 80.6747 70.168 83.0147 69.318 84.7147C68.478 86.4047 67.558 87.4447 65.838 88.2247C64.108 89.0047 61.568 89.5247 57.178 89.8847C52.778 90.2447 46.538 90.4447 39.368 90.2147C32.208 89.9847 24.138 89.3347 18.568 88.6147C13.008 87.9047 9.948 87.1247 7.768 85.9847C5.588 84.8447 4.278 83.3447 3.238 81.2647C2.198 79.1747 1.418 76.5047 1.028 73.2247C0.637997 69.9347 0.637997 66.0247 1.158 61.0447C1.678 56.0647 2.718 50.0147 4.278 43.0747C5.848 36.1447 7.928 28.3347 9.648 22.8947C11.378 17.4547 12.748 14.3947 14.438 11.7347C16.128 9.06467 18.148 6.78467 20.658 5.02467C23.158 3.26467 26.158 2.02467 28.858 1.37467C31.558 0.724674 33.968 0.664674 36.118 0.824674Z"
        fill="#E6E6E6"
        stroke="black"
        strokeWidth="1.5"
        strokeMiterlimit="2.61313"
      />
    </svg>
  )
}
